<template>
  <div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input type="text" class="form-control" v-model="filtros.pesquisa" placeholder="Pesquisa: Entre com NOME ou CÓDIGO do procedimento" @keyup.enter="filtrar">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <select v-model="filtros.tipo_limite" class="form-control">
            <option value="">--Tipo de Limite--</option>
            <option value="0">Procedimento</option>
            <option value="1">Subgrupo</option>
            <option value="2">Geral</option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <button @click="filtrar" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    filters: {

    },
    data: () => ({
      filtros: {
        pesquisa: '',
        tipo_limite: ''
      },
    }),

    mounted () {

    },

    methods: {
      filtrar: function() {
        this.$emit('filtrar', this.filtros);
      }
    },
    watch: {

    },

    components: {

    }

  }
</script>


// WEBPACK FOOTER //
// filtroContratoProcedimento.vue?3657e4db